module.exports = __webpack_public_path__ + "img/icon_pjzgsj.33e407b4.png";